export const SET_CONTACT = "SET_CONTACT";
export const SET_REFERRAL = "SET_REFERRAL";
export const SET_COUNTRY_LIST = "SET_COUNTRY_LIST";
